import Crud from '../components/Curiosity/Crud'
import Add from '../components/Curiosity/Add'
import Edit from '../components/Curiosity/Edit'

let routes = {
    path: '/curiosity',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/curiosity',
            component: Crud
        },
        {
            path: '/curiosity/add',
            component: Add
        },
        {
            path: '/curiosity/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/curiosity.js